import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

export default class extends Controller {
  static targets = ["startDate", "endDate"];

  connect() {
    this.initializeDatePickers();
  }

  initializeDatePickers() {
    const options = {
      dateFormat: "Y-m-d",
      locale: {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
          longhand: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
        },
        months: {
          shorthand: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
          longhand: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        }
      }
    };

    if (this.hasStartDateTarget) {
      this.startPicker = flatpickr(this.startDateTarget, {
        ...options,
        onChange: (selectedDates, dateStr) => {
          // Actualizar minDate del endDate cuando cambia startDate
          if (this.hasEndDateTarget && this.endPicker) {
            this.endPicker.set("minDate", dateStr);
          }
        }
      });
    }

    if (this.hasEndDateTarget) {
      const startDateValue = this.hasStartDateTarget ? this.startDateTarget.value : null;
      this.endPicker = flatpickr(this.endDateTarget, {
        ...options,
        minDate: startDateValue || null
      });
    }
  }

  disconnect() {
    if (this.startPicker) {
      this.startPicker.destroy();
    }
    if (this.endPicker) {
      this.endPicker.destroy();
    }
  }
}
